export default class Message {
  id!: string
  message!: string
  createdBy!: string
  createdAt!: string
}
